import React from "react";
import Select, { components } from "react-select";
import { useSelector } from "react-redux";
import { Col, Form } from "react-bootstrap";
import CopyToClipboard from "components/Site/SiteView/SiteOverview/Tabs/CopyToClipboard";
import Icon from "components/Icons/Icon";
import { darkModeSelectStyles } from "components/Common/CustomStyles/darkModeSelectStyles";

  // Custom Select Component and Options -----
  const CustomOption = (props) => {
    const { data } = props;

    if (!data?.label || !data?.value) { return null };

    return (
      <components.Option {...props}>
        <div className='d-flex align-items-center pl-1 pr-1'>
          <Icon style={{ color: data?.colour ?? 'lightgray' }} className='fas fa-circle fa-xs mr-2' />
          <span>{data.label}</span>
        </div>
      </components.Option>
    );
  };
  const CustomSingleValue = (props) => {
    const { data } = props;

    if (!data?.label || !data?.value) { return null };

    return (
      <components.SingleValue {...props}>
        <div className='d-flex align-items-center pl-1 pr-1'>
          <Icon style={{ color: data?.colour ?? 'lightgray' }} className='fas fa-circle fa-xs mr-2' />
          <span>{data.label}</span>
        </div>
      </components.SingleValue>
    );
  };
  // -----------

const CustomFieldDropdown = React.memo(function CustomField({ field, value, options, editMode, onChange, showLabel = true, useCol = true, colSizes = {}, maxLength = 50, customStyle = {} }) {
  const darkMode = useSelector((state) => state.app.darkMode)
  
  const fieldName = field?.field_name;

  const safeOptions = options ?? [];

  return (
    <>
    {useCol ?
      <Col
        id={field?.id}
        sm={colSizes?.sm ? colSizes.sm : 12} 
        md={colSizes?.md ? colSizes.md : 6}
        lg={colSizes?.lg ? colSizes.lg : 6}
        className={`detail-field ${useCol && customStyle?.col ? customStyle?.col : ""}`}
      >
        {showLabel &&
          <div className="d-flex flex-row">
            <Form.Label className="form-input-labels">{fieldName}</Form.Label>
            {(!editMode && value) && <CopyToClipboard id={fieldName} copyText={value?.label} />}
          </div>
        }
        <Select
          data-intercom-target={`${fieldName}-input-field`}
          components={{ Option: CustomOption, SingleValue: CustomSingleValue }}
          options={safeOptions}
          type="text"
          maxLength={maxLength}
          name={`${fieldName}_input`}
          className={`
            ${!editMode ? "site-details-read-only" : "edit-mode"} 
            ${customStyle?.control ? customStyle?.control : ""}
          `}
          placeholder="Select an option..."
          value={value ?? { label: "", value: "" }}
          onChange={(option) => onChange(field, option.value)}
          styles={{
            ...(darkMode ? darkModeSelectStyles : ""),
            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
            container: (base, { selectProps }) => ({
              ...base,
              ...(selectProps?.menuIsOpen ? {
                position: 'relative',
                zIndex: 9999,
              } : {})
            }),
          }}
        />
      </Col>
    :
      <span>
        {showLabel &&
          <div className="d-flex flex-row">
            <Form.Label className="form-input-labels">{fieldName}</Form.Label>
            {(!editMode && value) && <CopyToClipboard id={fieldName} copyText={value} />}
          </div>
        }
        <Select
          data-intercom-target={`${fieldName}-input-field`}
          components={{ Option: CustomOption, SingleValue: CustomSingleValue }}
          options={safeOptions}
          type="text"
          maxLength={maxLength}
          name={`${fieldName}_input`}
          className={`
            ${!editMode ? "site-details-read-only" : "edit-mode"} 
            ${customStyle?.control ? customStyle?.control : ""}
          `}
          placeholder="Select an option..."
          value={value ?? { label: "", value: "" }}
          onChange={(e) => onChange(field, e.target.value)}
          styles={{
            ...(darkMode ? darkModeSelectStyles : ""),
            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
            container: (base, { selectProps }) => ({
              ...base,
              ...(selectProps?.menuIsOpen ? {
                position: 'relative',
                zIndex: 9999,
              } : {})
            }),
          }}
        />
      </span>
    }
    </>
  );
}, (prevProps, nextProps) => {
  // prevent re-render unless relevant data changes
  return (
    prevProps?.value === nextProps?.value &&
    prevProps?.editMode === nextProps?.editMode &&
    prevProps?.field?.id === nextProps?.field?.id &&
    prevProps?.enableWindowSize === nextProps?.enableWindowSize &&
    prevProps?.customStyle?.col === nextProps?.customStyle?.col &&
    prevProps?.customStyle?.control === nextProps?.customStyle?.control
  );
});

export default CustomFieldDropdown;